import React, { useState } from 'react';
import { Gamepad2, Play, Trophy, Activity, Sparkles } from 'lucide-react';

export const GamifiedNeuroModule: React.FC = () => {
  const [score, setScore] = useState(120);
  const [reactionMs, setReactionMs] = useState(320);

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-purple-500/20 text-purple-300 text-xs font-bold rounded-full border border-purple-500/30">
            <Gamepad2 className="w-3.5 h-3.5" /> Module 29: WebGL Gamified Biofeedback Neuro-Rehab Drills
          </div>
          <h2 className="text-2xl font-black mt-2">Interactive Target Tracking & Reaction Time Drill</h2>
        </div>
        <div className="text-right">
          <div className="text-2xl font-black text-purple-400 font-mono">{score} PTS</div>
          <div className="text-xs text-slate-400">Biofeedback Score</div>
        </div>
      </div>

      <div className="bg-slate-950 p-6 rounded-2xl border border-slate-800 space-y-4 text-center">
        <div className="text-xs font-bold text-slate-400 flex items-center justify-center gap-2">
          <Activity className="w-4 h-4 text-emerald-400" /> Reaction Latency: <span className="text-emerald-400 font-mono text-base">{reactionMs} ms</span>
        </div>
        <div className="w-full h-48 bg-slate-900 border-2 border-dashed border-purple-500/40 rounded-2xl flex items-center justify-center relative overflow-hidden">
          <button 
            onClick={() => {
              setScore(score + 15);
              setReactionMs(Math.max(180, reactionMs - 12));
            }}
            className="w-16 h-16 bg-gradient-to-tr from-purple-600 to-pink-500 rounded-full font-black text-xs text-white shadow-lg shadow-purple-500/40 animate-pulse hover:scale-110 transition"
          >
            TARGET
          </button>
        </div>
        <p className="text-xs text-slate-400">Click or tap the moving Target to train fine-motor precision & visual tracking.</p>
      </div>
    </div>
  );
};
